import React from "react"
import styled, { css } from "styled-components"

import { ParagraphLarge, Eyebrow } from "components/text"

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>

export const PaginationPage = styled(Eyebrow).attrs({
  fontSize: ["1.125rem", null, "1.5rem"],
  forwardedAs: "button",
  mx: 4
})<
  {
    active?: boolean
  } & ButtonProps
>`
  color: ${props => props.theme.colors.evergreen};

  ${props =>
    props.active &&
    css`
      color: ${props.theme.colors.seafoamBlue};
    `};
`

export const PaginationNavigationLink = styled(ParagraphLarge).attrs({
  fontSize: ["1rem", null, "1.125rem"],
  forwardedAs: "button"
})<ButtonProps>`
  color: ${props => props.theme.colors.evergreen};
`

export const PaginationDots = styled(ParagraphLarge).attrs({
  forwardedAs: "button",
  fontSize: ["1.125rem", null, "1.5rem"]
})<ButtonProps>``
